import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { FilterBar, Menu, Page, SearchBar, Select, Switch, hasActiveFilters, } from "@sscs/ui";
import { produce } from "immer";
import { filesDiffID } from "../../../constants";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectFilteredByLink, selectPagination, selectSort, } from "../../../store/filesDiffSlice";
import { selectScrollTo } from "../../../store/sdlcReportSlice";
import { useReportDispatch, useReportSelector, useScrollIntoView, } from "../../hooks";
import { getQueryStatus, isFilteredByLink } from "../../utils";
import styles from "./diff.module.scss";
import DiffFileList from "./DiffFileList";
import { useGetFilesDiff } from "./useGetFilesDiff";
const FileChanges = () => {
    const dispatch = useReportDispatch();
    const scrollTo = useReportSelector(selectScrollTo);
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: fetchedData, isLoading, isFetching, isError, error, } = useGetFilesDiff();
    const data = fetchedData
        ? fetchedData
        : {
            files: [],
            match_count: 0,
            next_page: "",
            previous_page: "",
        };
    useScrollIntoView(scrollTo, filesDiffID);
    const handleFilterChange = (filter) => {
        dispatch(filterUpdated(filter));
    };
    const handleSearchChange = (value) => {
        /* Update debounced filter only when not set via redux action
         *
         * Updating when set via action will cause file id to be reset
         * and multiple files endpoint will be queried instead of specific item endpoint */
        if (filter.file_name !== value) {
            handleFilterChange(produce(filter, (draftState) => {
                draftState.file_name = value;
            }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Page.Filters, { id: filesDiffID, found: {
                id: "diff-modified-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => handleFilterChange(initFilter),
            } },
            React.createElement(FilterBar, { filters: [
                    {
                        id: "file-name",
                        control: (React.createElement(SearchBar, { id: "diff-search", value: filter.file_name, onChange: handleSearchChange, label: "Regex search for file name", slotProps: { htmlInput: { maxLength: 256 } }, className: styles.search, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "file_name", filteredByLink) })),
                    },
                    {
                        id: "change-type",
                        width: "240px",
                        control: (React.createElement(Select, { id: "diff-filter-change-types", value: filter.change_type, onChange: (value) => {
                                if (SDLCMetadataTypeGuards.stringIsDiffChange(value) ||
                                    value === "ALL")
                                    handleFilterChange(produce(filter, (draft) => {
                                        draft.change_type = value;
                                    }));
                            }, className: styles["change-filter"] },
                            React.createElement(Menu.Item, { id: "show-all-change-types", value: "ALL" }, "Show all change types"),
                            React.createElement(Menu.Item, { id: "filtered-by-added", value: "added" }, "Filtered by added"),
                            React.createElement(Menu.Item, { id: "filtered-by-removed", value: "removed" }, "Filtered by removed"),
                            React.createElement(Menu.Item, { id: "filtered-by-changed", value: "changed" }, "Filtered by changed"))),
                    },
                    {
                        id: "behavior-changes",
                        fit: true,
                        control: (React.createElement(Switch, { title: "Filter changes", label: "Behavior changes only", checked: filter.has_behavior_changes, onChange: (event) => handleFilterChange(produce(filter, (draft) => {
                                draft.has_behavior_changes = event.target.checked;
                            })) })),
                    },
                ] })),
        React.createElement(Page.Body, null,
            React.createElement(DiffFileList
            // Force rerender of the table to collapse expanded rows when filter/pagination/sort changes
            , { 
                // Force rerender of the table to collapse expanded rows when filter/pagination/sort changes
                key: `${JSON.stringify(filter)} ${JSON.stringify(sort)} ${JSON.stringify(pagination)}`, files: data.files, filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => handleFilterChange(initFilter),
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data: fetchedData,
                }), itemCount: data.match_count, pagination: pagination, onPaginationChange: (pagination) => dispatch(paginationUpdated(pagination)) }))));
};
export default FileChanges;
//# sourceMappingURL=FileChanges.js.map